var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5C8.78417 0.5 15.5 7.21583 15.5 15.5H13C13 8.59667 7.40333 3 0.5 3V0.5ZM0.5 6.33333C5.5625 6.33333 9.66667 10.4375 9.66667 15.5H7.16667C7.16667 13.7319 6.46429 12.0362 5.21405 10.786C3.9638 9.53571 2.26811 8.83333 0.5 8.83333V6.33333ZM0.5 12.1667C1.38405 12.1667 2.2319 12.5179 2.85702 13.143C3.48214 13.7681 3.83333 14.6159 3.83333 15.5H0.5V12.1667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi2);
export default __webpack_public_path__ + "static/media/wifi2.a98ab77973ddc81029c0ffec2c55ccb4.svg";
export { ForwardRef as ReactComponent };